// "Fine ricorrenza": never / until a date / after N occurrences
export const endFromTask = (t) => ({
  endType: t?.recurrenceCount ? "count" : t?.recurrenceUntil ? "until" : "never",
  until: t?.recurrenceUntil || "",
  count: t?.recurrenceCount || 10
});

export const endToFields = (end) => ({
  recurrenceUntil: end.endType === "until" ? (end.until || null) : null,
  recurrenceCount: end.endType === "count" ? Math.max(1, Number(end.count) || 1) : null
});

const field = "w-full min-w-0 px-3 py-2 bg-white border border-[#E4E7E1] rounded-lg text-sm text-[#3B443D] focus:outline-none focus:border-[#A3B897]";

export const RecurrenceEndFields = ({ value, onChange, testIdPrefix, minDate }) => (
  <div className="col-span-2 grid grid-cols-2 gap-3" data-testid={`${testIdPrefix}-recurrence-end`}>
    <div className="min-w-0">
      <div className="tl-label mb-1">Fine ricorrenza</div>
      <select
        data-testid={`${testIdPrefix}-recurrence-end-type`}
        value={value.endType}
        onChange={(e) => onChange({ ...value, endType: e.target.value })}
        className={field}
      >
        <option value="never">Per sempre</option>
        <option value="until">Fino al giorno…</option>
        <option value="count">Per N volte</option>
      </select>
    </div>
    {value.endType === "until" && (
      <div className="min-w-0">
        <div className="tl-label mb-1">Ultimo giorno</div>
        <input
          type="date"
          required
          min={minDate || undefined}
          data-testid={`${testIdPrefix}-recurrence-until`}
          value={value.until}
          onChange={(e) => onChange({ ...value, until: e.target.value })}
          className={field}
        />
      </div>
    )}
    {value.endType === "count" && (
      <div className="min-w-0">
        <div className="tl-label mb-1">Quante volte</div>
        <input
          type="number"
          min={1}
          max={999}
          required
          data-testid={`${testIdPrefix}-recurrence-count`}
          value={value.count}
          onChange={(e) => onChange({ ...value, count: e.target.value })}
          className={field}
        />
      </div>
    )}
  </div>
);
